// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"157":"8911c4fd84ec1a416a71","192":"73897fb3a6297c80182f","336":"958f21d7a6738d50a61a","538":"93d1f530647706a51c6e","607":"237b88a9d186588f26ca"}[chunkId] + ".min.js";
};